import classNames from 'classnames';
import React, { memo } from 'react';
import { PresentationStyles } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { Message } from '@wg/wows-react-uikit';

import { formatNumber, t } from '~/helpers/localization';

import { getPatrolRewardItemDataWE } from '~/pages/Patrols/helpers';

import styles from './PatrolsReward.module.scss';

import type { IPatrolReward } from '~/types/patrols';

type IProps = {
  reward: IPatrolReward;
  isPending?: boolean;
  isGlowing?: boolean;
  isClaimed?: boolean;
  isLosable?: boolean;
  isFailed?: boolean;
  isSuper?: boolean;
};

const PatrolsReward: React.FC<IProps> = ({ reward, isPending, isGlowing, isClaimed, isSuper, isLosable, isFailed }) => {
  const item = reward.items[0];
  const itemDataWE = getPatrolRewardItemDataWE(item);

  return (
    <div
      className={classNames(styles.reward, {
        [styles.glowing]: isGlowing,
        [styles.claimed]: isClaimed,
        [styles.losable]: isLosable,
        [styles.pending]: isPending,
        [styles.super]: isSuper,
      })}
    >
      <WoWSEntity
        className={styles.container}
        type={itemDataWE.type}
        id={itemDataWE.id}
        amount={item.amount}
        presentation={{
          bindTooltip: true,
          withTooltip: true,
          withText: true,
          hideReceiveText: true,
          renderWithoutFade: true,
        }}
        customisation={{
          isExistsInInventory: isClaimed,
        }}
      >
        {reward.image ? (
          <img className={styles.image} src={reward.image} width={300} height={300} />
        ) : (
          <WoWSEntity
            className={styles.entity}
            type={itemDataWE.type}
            id={itemDataWE.id}
            presentation={{
              style: PresentationStyles.WIDGET,
              withTooltip: false,
              withText: false,
            }}
          />
        )}
        <span className={styles.amount}>{formatNumber(item.amount)}</span>
      </WoWSEntity>
      {isLosable ? (
        <div className={styles.warning}>
          <Message type={'warning'} style={'inline'}>
            <span className={styles.error}>{t('This reward will be lost')}</span>
          </Message>
        </div>
      ) : isFailed ? (
        <div className={styles.warning}>
          <Message type={'error'} style={'inline'}>
            <span className={styles.error}>{t('Something Went Wrong')}</span>
          </Message>
        </div>
      ) : null}
    </div>
  );
};

export default memo(PatrolsReward);
